import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ReportDraftVisualNodeContext = createContext({
  templateDocument: null,
});

export function ReportDraftVisualNodeProvider({ value, children }) {
  return (
    <ReportDraftVisualNodeContext.Provider value={value || { templateDocument: null }}>
      {children}
    </ReportDraftVisualNodeContext.Provider>
  );
}

ReportDraftVisualNodeProvider.propTypes = {
  value: PropTypes.shape({
    templateDocument: PropTypes.object,
  }),
  children: PropTypes.node,
};

ReportDraftVisualNodeProvider.defaultProps = {
  value: null,
  children: null,
};

export function useReportDraftVisualNodeContext() {
  return useContext(ReportDraftVisualNodeContext);
}

